import { Chip, styled } from '@mui/material';

// chip
const CustomisedChip = styled(Chip)(({ theme, color, variant }) => ({
    borderRadius: theme.typography.borderRadius.xxxSmall,
    textAlign: 'center',
    height: 'fit-content',
    fontSize: theme.typography.customFontSize.xSmall, // 12px
    lineHeight: theme.typography.customFontSize.medium,
    fontWeight: theme.typography.fontWeightSemiBold, //600

    '& .MuiChip-label': {
        padding: `${theme.typography.generic.xxxSmall} ${theme.typography.generic.xSmall} `,
    },
    ...(color === 'default' &&
        variant === 'outlined' && {
            border: `1px solid ${theme.palette.border.neutralPrimary}`,
            backgroundColor: theme.palette.background.neutralSecondary,
            color: theme.palette.text.neutralSecondary,
        }),

    ...(color === 'success' &&
        variant === 'outlined' && {
            color: theme.palette.text.neutralSecondary,
            border: `1px solid ${theme.palette.success.main}`,
            backgroundColor: theme.palette.background.default,
        }),

    ...(color === 'error' &&
        variant === 'outlined' && {
            color: theme.palette.text.neutralSecondary,
            border: `1px solid ${theme.palette.error.main}`,
            backgroundColor: theme.palette.background.default,
        }),

    ...(color === 'warning' &&
        variant === 'outlined' && {
            border: `1px solid #ffcf78`,
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.neutralSecondary,
        }),

    // ...(color === 'success' &&
    //     variant === 'contained' && {
    //         // color: theme.palette.success.dark,

    //         border: `1px solid ${theme.palette.success.main}`,
    //         backgroundColor: theme.palette.success.light,
    //     }),

    // ...(color === 'primary' &&
    //     variant === 'outlined' && {
    //         border: `1px solid ${theme.palette.border.neutralPrimary}`,
    //         backgroundColor: theme.palette.background.neutralSecondary,
    //         // color: theme.palette.text.neutralSecondary,
    //     }),
}));

export const CustomChip = ({ label = 'chip', sx = {}, variant = '', color = '', ...props }) => {
    return (
        <CustomisedChip
            color={color || 'default'}
            variant={variant || 'outlined'}
            label={label}
            sx={{
                ...sx,
            }}
            {...props}
        />
    );
};
// CustomisedChip Component (Styled Chip)
/**
 * CustomisedChip
 *
 * A styled version of the MUI Chip component with customized styles based on theme colors,
 * variants, and specific color states. It includes specific designs for `outlined` and
 * `contained` variants and different colors like `primary`, `success`, and `error`.
 *
 * @param {string} color - Color of the Chip component (e.g., 'primary', 'success', 'error').
 * @param {string} variant - Variant style of the Chip component ('outlined' or 'contained').
 */
